import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions'
import { resetPasswordConfirmAsyncThunk } from '../actions/AuthActions'
import { ThunkDispatch } from 'redux-thunk';
import { RouteComponentProps } from 'react-router';
import FirebaseAction from '../components/FirebaseActions/FirebaseAction';


const mapStateToProps = (state: RootState) => {
    return ({
        resetPasswordConfirmMessage: state.authRdc.passwordResetConfirmMessage,
        resetPasswordConfirmSuccess: state.authRdc.passwordResetConfirmSuccess,
        resetPasswordConfirmBusy: state.authRdc.passwordResetConfirmBusy
    })
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return {
        resetPasswordConfirm: async (code: string, newPassword: string) => {
            await dispatch(resetPasswordConfirmAsyncThunk(code, newPassword))
        }
    }
}

export type FirebaseActionProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any>

const FirebaseActionCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(FirebaseAction);

export default FirebaseActionCnn